import { render, staticRenderFns } from "./SectionNotifications.vue?vue&type=template&id=3a1d134a&scoped=true"
import script from "./SectionNotifications.vue?vue&type=script&lang=ts"
export * from "./SectionNotifications.vue?vue&type=script&lang=ts"
import style0 from "./SectionNotifications.vue?vue&type=style&index=0&id=3a1d134a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1d134a",
  null
  
)

export default component.exports